module.exports = __webpack_public_path__ + "static/media/Help.e68b3aeb.png";